import React from 'react';

const Delaware = () => (
  <svg
    width="14"
    height="24"
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.52427 23.5415C5.13707 16.0359 0.0681819 8.57257 0.920039 1.0177C2.36327 1.44015 2.24359 0.299531 3.47561 0.503716C3.7713 1.9471 2.46886 2.76384 2.45478 4.08753C2.41958 6.49551 4.33448 8.62186 6.03819 9.72023C6.29868 11.6706 6.73519 12.6492 8.0869 14.325C9.35412 15.8951 9.44565 17.0287 12.1843 16.8879C12.0223 18.0919 11.3746 18.81 11.6703 20.4717C11.7618 21.2955 14.1062 19.6408 13.719 22.0066C10.7129 22.2389 8.62194 23.3936 5.52427 23.5415Z"
      fill="#FC374D"
    />
  </svg>
);
export default Delaware;
